module.exports = __webpack_public_path__ + "img/notification.b0fbb229.svg";